<template>
    <div class="customer-profile">
        <div class="content-area">
            <base-header
                :menu-listing="allowedMenuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            allowedMenuListing: [],
            menuListing: [
                {
                    anchorLink: '/customer-profiles/all-customer',
                    menuLabel: 'All Customers',
                    name: 'view-customer-profile',
                    permission: ['view-customer-profile'],
                },
                {
                    anchorLink: '/customer-profiles/advance-search',
                    menuLabel: 'Advance Search',
                    name: 'advance-search',
                    permission: ['view-customer-profile'],
                },
                {
                    anchorLink: '/customer-profiles/bulk-customers-onboarding',
                    menuLabel: 'Bulk Customer Onboarding',
                    name: 'bulk-customers-onboarding',
                    permission: ['bulk-upload'],
                },
            ],

            selected: '1',

            options: [
                { text: 'All', value: '1' },
                { text: 'Pending Review', value: '2' },
                { text: 'Approved', value: '3' },
                { text: 'Rejected', value: '4' },
            ],
        }
    }, // End of Component > data

    watch: {
        dataSegmentId(value) {
            if (value) {
                this.goToFirstStep()
                this.checkOcrSwitch()
            }
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.goToFirstStep()
        this.checkOcrSwitch()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async checkOcrSwitch() {
            try {
                let { data } = await request({
                    url: `/configurations/ocr/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
                // console.log('data ', data.data)
                this.allowedMenuListing = []
                if (data.data.restrictBulkOnboarding) {
                    let tempArr = Array.from(this.menuListing)

                    for (let i = 0; i < tempArr.length; i++) {
                        if (tempArr[i].name !== 'bulk-customers-onboarding') {
                            this.allowedMenuListing.push(tempArr[i])
                        }
                    }
                } else {
                    this.allowedMenuListing = Array.from(this.menuListing)
                }
            } catch (error) {
                console.log(error)
            }
        }, // End of checkOcrSwitch() method

        goToFirstStep() {
            if (!['view-customer-profile'].includes(this.$route.name)) {
                this.$router.push({
                    name: 'view-customer-profile',
                })
            }
        }, // End of goToFirstStep() method
    }, // End of Component > mounted
} // End of export default
</script>
